import { defineComponent as _defineComponent } from 'vue'
import InvoicesActionContractSelector from '@/views/my-projects/components/invoices/action-box/InvoicesActionContractSelector.vue';
import InvoicesActionContractDetails from '@/views/my-projects/components/invoices/action-box/InvoicesActionContractDetails.vue';
import { onMounted, ref } from 'vue';
import useMessengerState from '@/state/messenger/messengerState';
import { useRouter } from 'vue2-helpers/vue-router';
import { Contract } from '@/models/Contracts';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { PayloadCreateInvoice } from '@/models/Invoice';
import useInvoiceActionState from '@/views/my-projects/components/invoices/action-box/useInvoiceActionState';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesNewInvoiceAction',
  setup(__props) {

const { fetchCreateInvoice, filteredContracts, fetchAllContracts } = useInvoice();
const { mode } = useInvoiceActionState();

const router = useRouter();
const { tUserFallback: t } = useUser('self');

const selectedContract = ref<Contract | null>(null);

const { isOpened: isMessengerOpened } = useMessengerState();

const onSelect = (contract: Contract) => {
  selectedContract.value = contract;
  isMessengerOpened.value = false;
};

const onCreateInvoice = async () => {
  const payload = {
    contractId: selectedContract.value?.contractId,
    invoiceType: 'INVOICE'
  };
  await fetchCreateInvoice(0, payload as PayloadCreateInvoice)
    .then(async (data) => {
      mode.value = '';
      await router.push(`/my-projects/invoice/${data?.invoiceId ?? ''}`);
    });
};

onMounted(async () => {
  await fetchAllContracts();
});

return { __sfc: true,fetchCreateInvoice, filteredContracts, fetchAllContracts, mode, router, t, selectedContract, isMessengerOpened, onSelect, onCreateInvoice, InvoicesActionContractSelector, InvoicesActionContractDetails }
}

})